module.exports = __webpack_public_path__ + "static/img/wx_tp_jcjg.png";